import { ChangeDetectorRef, Component, forwardRef, Input, OnDestroy } from '@angular/core';
import {
  AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors,
  Validator
} from '@angular/forms';
import { cloneDeep } from 'lodash-es';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import {
  RangeOrRelativeDateInputModel
} from 'shared/components/range-or-relative-date-input/range-or-relative-date-input.component';

export interface DateTagDateRangeModel {
  range_start: string;
  range_end: string;
  date_relative_offset: number;
}
@Component({
  selector: 'app-date-tag-range-query-input',
  templateUrl: `./date-tag-range-query-input.component.html`,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DateTagRangeQueryInputComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => DateTagRangeQueryInputComponent), multi: true }
  ]
})
export class DateTagRangeQueryInputComponent
  extends WithDisposableSubject() implements ControlValueAccessor, Validator, OnDestroy {

  private _data: DateTagDateRangeModel;

  dateInputModel: RangeOrRelativeDateInputModel = {
    startDate: null,
    endDate: null,
    relativeOffset: null
  };

  /** Disabled state of the input */
  @Input() disabled: boolean;


  // For ControlValueAccessor interface
  public onChangeCallback: () => void;
  public onTouchedCallback: () => any;

  // ----------ControlValueAccessor Implementation----------
  @Input()
  get value(): DateTagDateRangeModel {
    return this._data;
  }
  set value(value: DateTagDateRangeModel) {
    // When component is initialized without a formControl, null is passed to value
    if (value) {
      this._data = value;
      this._data.date_relative_offset = value?.date_relative_offset;
      this.dateInputModel.startDate = value?.range_start;
      this.dateInputModel.endDate = value?.range_end;
      this.dateInputModel.relativeOffset = value?.date_relative_offset;
      this.handleDataChange();
    }
  }


  constructor(private _cd: ChangeDetectorRef) {
    super();
  }


  datesChanged(event: RangeOrRelativeDateInputModel) {
    if (this._data === undefined) {
      return;
    }
    this.dateInputModel = event;
    this._data.range_start = event?.startDate;
    this._data.range_end = event?.endDate;
    this._data.date_relative_offset = event?.relativeOffset;
    this.handleDataChange();
  }

  // ----------Validator Implementation----------
  validate(_control: AbstractControl): ValidationErrors | null {
    return null;
  }

  writeValue(obj: DateTagDateRangeModel): void {
    if (obj == null) {
      return;
    }
    this.value = cloneDeep(obj);
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = () => fn(this.value);
  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = () => fn(this.value);
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this._cd.detectChanges();
  }

  // ----------END----------

  private handleDataChange(): void {
    this._cd.markForCheck();
    if (this.onChangeCallback) {
      this.onChangeCallback();
    }
  }

}
